module.exports = __webpack_public_path__ + "static/Im-He-2.7de9d8fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/gallery/Im-He-2.jpg
// module id = 525
// module chunks = 27362984104999